import React from 'react';
import Meta from './../components/Meta';
import DashboardSection from './../components/Dashboard/DashboardSection';

function DashboardPage(props) {
  return (
    <>
      <Meta title="Dashboard" />
      <DashboardSection />
    </>
  );
}

export default DashboardPage;
